import { capitalizeFirstLetter } from "helpers/utils";
import type { TParamsPagination } from "store/types";

/**
 * Save management general filter in local storage + adapt mui arrow icon
 */
export const saveFilter = (
    options: TParamsPagination,
    isNewOption: boolean,
    storedOptions: TParamsPagination,
    type: string | undefined,
) => {
    if (!type) return;
    localStorage.setItem("managementSortBy", JSON.stringify({ [type]: options }));

    if (isNewOption) {
        resetSortLabelArrow(storedOptions);
    } else {
        const { arrowIcon } = getSortElements(options.sortBy as string);
        const sortOrder = capitalizeFirstLetter(options.sortOrder as string);
        if (arrowIcon) {
            arrowIcon.style.transform = sortArrow[sortOrder].transform;
        }
    }
};

/**
 * Reset Mui table arrow + label filter origin class
 */
export const resetSortLabelArrow = (storedOptions: TParamsPagination) => {
    const { btnChild: prevBtnChild } = getSortElements(storedOptions.sortBy as string);
    prevBtnChild?.classList?.remove("Mui-active");
};

/**
 * Search for a fitler in local storage and set it by default
 */
export const recallFilter = (options: TParamsPagination) => {
    const sortOrder = capitalizeFirstLetter(options.sortOrder as string);
    const { btnChild, arrowIcon } = getSortElements(options.sortBy as string);

    btnChild?.classList?.add("Mui-active");

    if (arrowIcon) {
        arrowIcon.style.transform = sortArrow[sortOrder].transform;
        sortArrow[sortOrder].toggleClass(arrowIcon);
    }
};

/**
 * Get HTML sort element of Management table
 * @param sortKey html element head cell key
 */
const getSortElements = (sortKey: string) => {
    const tableHeadCellEl = document.querySelector(`#table-head-cell-sortBy-${sortKey}`);
    const btnChild = tableHeadCellEl?.querySelector(".MuiButtonBase-root");
    const arrowIcon = btnChild?.querySelector(".MuiSvgIcon-root") as HTMLElement;

    return { btnChild, arrowIcon };
};

const sortArrow = {
    Asc: {
        transform: "rotate(180deg)",
        toggleClass: (arrow: HTMLElement) => {
            arrow.classList.remove(".MuiTableSortLabel-iconDirectionDesc");
            arrow.classList.add(".MuiTableSortLabel-iconDirectionAsc");
        },
    },
    Desc: {
        transform: "rotate(0deg)",
        toggleClass: (arrow: HTMLElement) => {
            arrow.classList.remove(".MuiTableSortLabel-iconDirectionAsc");
            arrow.classList.add(".MuiTableSortLabel-iconDirectionDesc");
        },
    },
};
